import DataParser from './data-parser';
import { ChangeEvent } from 'react';
import { useDecisionTreeStore } from '../dal/decision-tree-store';
import { saveDecisionTreeCsvToStorage } from '../dal/decision-tree-storage';

const Parameters = () => {

    const csv = useDecisionTreeStore(store => store.csv);
    const setCsv = useDecisionTreeStore(store => store.setCsv);

    const onTextAreaChange = (evt: ChangeEvent<HTMLTextAreaElement>) => {
        setCsv(evt.target.value);
        saveDecisionTreeCsvToStorage(evt.target.value);
    };

    /*const onTextAreaPaste = (evt: ClipboardEvent<HTMLTextAreaElement>) => {
        evt.preventDefault();
        const pastedText = evt.clipboardData.getData('text');
        const csv = pastedText.trim().replaceAll(/\t+/g,',').trim();

        if(csv) {
            setDecisionTreeTable(null);
            setDecisionTree(null);
        }
        else{
            setDecisionTreeTable(new DecisionTreeTable(csv, excludedColumns, forceBinningColumns, columnsRewrittenTypes));
            setDecisionTree(new DecisionTree(csv, excludedColumns, forceBinningColumns, columnsRewrittenTypes));
        }

        setCsv(csv);
    };*/

    return (
        <div className="flex flex-col">
                    <textarea
                        id="data"
                        onChange={ onTextAreaChange }
                        className="border rounded w-full p-2 border border-slate-400 shadow-md text-sm"
                        style={ {
                            width: '300px',
                            height: '500px',
                        } }
                        value={ csv }
                    />

            <DataParser />
        </div>
    )
};

export default Parameters;